import { NgModule } from "@angular/core";
import { ToastComponent } from "./toast.component";
import { FlexLayoutModule } from "@ngbracket/ngx-layout";
import { CommonModule } from "@angular/common";
import { Toast } from "./toast";
import { OverlayModule } from "@angular/cdk/overlay";
import { MatIconModule } from "@angular/material/icon";
import { MatTooltipModule } from "@angular/material/tooltip";

@NgModule({
    imports: [
        OverlayModule,
        MatIconModule,
        MatTooltipModule,
        FlexLayoutModule,
        CommonModule
    ],
    declarations: [ToastComponent],
    exports: [ToastComponent],
    providers: [Toast]
})
export class ToastModule {}
